// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__lwh-N","logo_checkmark":"Logo_logo_checkmark__xQ-V3","logo_pabu":"Logo_logo_pabu__5Fdn5","logo_iz":"Logo_logo_iz__67llK"};